/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Divider } from 'src/@vymo/ui/atoms';
import { NoData } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { useAppSelector } from 'src/store/hooks';
import {
  getError,
  getIsMoreLoading,
  getIsMoreLoadingError,
  getLoading,
  getNotes,
} from './selectors';
import { NotesProps } from './types';
import MessageEditor from './view/editor';
import Note from './view/note';
import styles from './view/index.module.scss';

function Notes({ vo_id }: NotesProps) {
  const notes = useAppSelector(getNotes);
  const isLoading = useAppSelector(getLoading);
  const isLoadingMore = useAppSelector(getIsMoreLoading);
  const error = useAppSelector(getError);
  const loadingMoreError = useAppSelector(getIsMoreLoadingError);
  return (
    <div className={styles.noteView}>
      <div className={styles.noteView__notesList}>
        {Boolean(error || loadingMoreError) && (
          <NoData message={error || loadingMoreError} />
        )}
        {Boolean(isLoading || isLoadingMore) && (
          <SkeletonLoader rounded avtar lines={4} height={100} width="100%" />
        )}
        {Boolean(!isLoading && !error && notes.length === 0) && <NoData />}
        {notes.map((note, idx) => (
          <>
            <Note note={note} key={note.id || note._id} />
            {idx !== notes.length - 1 && (
              <Divider classNames={styles.noteView__divider} />
            )}
          </>
        ))}
      </div>
      <MessageEditor parentEditor voId={vo_id} />
    </div>
  );
}

export default Notes;
